import ApiService from '@/common/api/api.service';

const apiBasePath = 'BoletoPix';
const BoletoPixService = {
  async gerarBoletosDeTitulosIds(matriculaId, titulosIds) {
    const {data}  = await ApiService.post(`${apiBasePath}/emitir`, {
      matriculaId,
      titulosIds,
    });
    return data;
  },
  async gerarBoletos(form) {
    let { data } = await ApiService.post(
      `BoletoEmLote/adicionar`,
      form
    );
    return data;
  },
  async buscarStatusBoleto() {
    let { data } = await ApiService.get(`enumeradores/status-boleto`);
    return data.data;
  },
  async obterBoletosPorFiltro(filtro, paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${apiBasePath}/consultar`, {
      params: {
        ...filtro,
        NumeroDaPagina: paginacao.numeroDaPagina,
        TamanhoDaPagina: paginacao.tamanhoDaPagina,
        CampoOrdenado: campoOrdenado,
        OrdenacaoAscendente: ordem,
      },
    });
    return data;
  },
};

export default BoletoPixService;
